<template>
    <Filters
        :fieldsName="['search', 'obligation_type__id', 'document_type']"
        @onSearch="onSearch"
        @onClean="onClean"
        @onToggleVisibility="onToggleVisibility"
    >
        <template v-slot="{ fields }">
            <div class="columns is-variable is-1-desktop">
                <b-field class="column is-4">
                    <b-input
                        placeholder="Buscar"
                        v-model="fields.search"
                    ></b-input>
                </b-field>
                <b-field class="column is-5">
                    <b-select
                        data-testid="obligationTypeSelect"
                        v-model="fields.obligation_type__id"
                        placeholder="Todas las obligaciones"
                        expanded
                    >
                        <option
                            v-for="option in obligationTypesListFiltered"
                            :value="option.id"
                            :key="option.id"
                        >
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>
                <b-field class="column is-3">
                    <b-select
                        data-testid="obligationDocTypeSelect"
                        v-model="fields.document_type"
                        placeholder="Todos los tipos"
                        expanded
                    >
                        <option
                            v-for="option in typeOptions"
                            :value="option.id"
                            :key="option.id"
                        >
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>
            </div>
        </template>
    </Filters>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { consoleHandlerError } from "@/utils/message";
import Filters from "@/components/filters/Filters";
export default {
    name: "FilterSearch",
    data() {
        return {
            rutMask: ["#.###.###-B", "##.###.###-B"],
            typeOptions: [
                { name: "Por pagar", id: "P" },
                { name: "Por cobrar", id: "C" },
            ],
            ticketTypes: ["Boleta electrónica", "Boleta exenta electrónica"],
        };
    },
    props: ["hasSiiAutomation"],
    components: {
        Filters,
    },
    computed: {
        ...mapState("taxDocument", ["obligationTypesList"]),
        ...mapState("userAuth", ["user"]),
        obligationTypesListFiltered: function() {
            let obligationsList = this.obligationTypesList.filter(
                (item) => item.name !== "Remuneraciones"
            );
            if (!this.hasSiiAutomation) {
                obligationsList = obligationsList.filter(
                    (item) => !this.ticketTypes.includes(item.name)
                );
            }
            return obligationsList;
        },
    },
    methods: {
        ...mapActions("taxDocument", ["getAllTaxDocuments"]),
        ...mapMutations("taxDocument", ["SET_TABLE_PARAMS"]),
        updateTable() {
            this.getAllTaxDocuments().catch((error) => {
                consoleHandlerError({ error, empty: true });
            });
        },
        onSearch: function(params) {
            if (params.search) {
                params.search = params.search.replace(/\./g, "");
            }
            this.SET_TABLE_PARAMS({ page: 1, ...params });
            this.updateTable();
        },
        onClean: function() {
            this.SET_TABLE_PARAMS({ page: 1 });
            this.updateTable();
        },
        onToggleVisibility: function(isVisible) {
            if (!isVisible) this.onClean();
        },
    },
};
</script>
